export default __webpack_public_path__ + "static/media/hotel-resort-img-19.a13558e7.jpg";